import { Link } from "react-router-dom";

export function FooterLogo() {
  return (
    <Link to="/" className="mb-4 flex items-center gap-2">
      <img 
        src="/lovable-uploads/30e09b3a-7f5e-4ff7-9a02-7dcfcd6951b6.png" 
        alt="Sibystock Logo" 
        className="h-12 w-auto"
      />
      <span className="text-2xl font-bold text-primary">Sibystock</span>
    </Link>
  );
}